const { SIMPLE } = require('../utils/redux-helpers');

module.exports = {
    NOTIFICATION: {
        PUSH: SIMPLE,
        SHOW: SIMPLE,
        DISMISS: SIMPLE
    }
};
